exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".service-info-detail-table th{border:0!important;font-weight:400;font-size:14px}.service-info-detail-table td{font-size:14px}.service-info-detail-table tr{border-bottom:1px solid #dbdbdb}", ""]);

// exports
